import { BdsButton, BdsGrid } from 'blip-ds/dist/blip-ds-react/components';
import { Label } from 'components/Label';
import { useLoadingContext } from 'contexts/LoadingContext';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ActualDate } from 'utils';
import './Update.scss';

export const Update = () => {
    const { t } = useTranslation();
    const { dataBlockIsLoading, upperMetricsIsLoading, setIsToUpdateAll } = useLoadingContext();
    const [lastUpdate, setLastUpdate] = useState<string>('');

    useEffect(() => {
        if (!dataBlockIsLoading && !upperMetricsIsLoading) {
            setLastUpdate(ActualDate());
        }
    }, [dataBlockIsLoading, upperMetricsIsLoading]);

    return (
        <BdsGrid alignItems="center" gap="2">
            <BdsGrid direction="column">
                <Label variant="fs-20" bold="bold" margin={false} className="update-title">
                    {t('go-personal-update-title')}
                </Label>
                <Label variant="fs-12" bold="regular" margin={false}>
                    {t('go-personal-update-last-updated', { lastUpdate })}
                </Label>
            </BdsGrid>
            <BdsButton
                variant="outline"
                color="content"
                icon="refresh"
                disabled={dataBlockIsLoading || upperMetricsIsLoading}
                onClick={() => setIsToUpdateAll(true)}
            >
                {t('go-personal-update-refresh')}
            </BdsButton>
        </BdsGrid>
    );
};
